export default __webpack_public_path__ + "static/media/success-changes-person-icon.c6bb00d3.svg";